import React, { useCallback } from 'react';
import EDTypography from '../../../../../../../../../BaseComponents/Typography/EDTypography';
import EDChip from '../../../../../../../../../BaseComponents/Chip/EDChip';
import EDAvatar from '../../../../../../../../../BaseComponents/Avatar/EDAvatar';
import EDIcon from '../../../../../../../../../BaseComponents/Icon/EDIcon';
import { IFilledLocalAnalys } from '../../../EkonomiskAnalysMain/EkonomiskAnalysMain';
import EDBox from '../../../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  analysSettings: IFilledLocalAnalys;
  sumLevel: number;
  setSumLevel: (newSumLevel: number) => void;
  marginTop?: number;
}

export const EkonomiskAnalysExportSumSettings: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { setSumLevel } = props;
  const onAvatarClick = useCallback(
    (index: number) => () => {
      if (index === 0) {
        setSumLevel(0);
      } else {
        setSumLevel(props.sumLevel === index ? index - 1 : index);
      }
    },
    [setSumLevel, props.sumLevel]
  );

  return (
    <EDBox sx={{ marginBottom: 2, marginTop: props.marginTop }}>
      <EDTypography sx={{ marginBottom: 1 }} variant="body2">
        Inkludera följande nivåer
      </EDTypography>
      <EDBox sx={{ maxWidth: 300 }}>
        {props.analysSettings.sums.map((sum, index) => (
          <EDChip
            key={index}
            avatar={
              <EDAvatar
                sx={{
                  '&:hover': {
                    cursor: 'pointer',
                  },
                  background:
                    props.sumLevel >= index
                      ? theme => theme.palette.primary.light
                      : undefined,
                }}
                onClick={onAvatarClick(index)}
              >
                <EDIcon avatarChildren iconType="drag_handle" />
              </EDAvatar>
            }
            label={<div>{sum.Namn ? sum.Namn : 'Namn Saknas'}</div>}
            fullWidth
            marginBottom={2}
          />
        ))}
      </EDBox>
    </EDBox>
  );
};

export default EkonomiskAnalysExportSumSettings;
